import {
  ContentState,
  EditorState,
  EntityInstance,
  Modifier,
  SelectionState,
  convertFromRaw,
  genKey,
} from 'draft-js';

import { DraftjsEntityType } from '@/modules/draft-js-link-plugin';

export const cleanEditorStateMentions = (state: EditorState): EditorState => {
  const contentState = state.getCurrentContent();
  let nextEditorState = state;

  contentState.getBlocksAsArray().forEach((block) => {
    const entities: {
      entityKey: string;
      blockKey: string;
      entity: EntityInstance;
      start: number;
      end: number;
    }[] = [];

    let selectedEntity: {
      entityKey: string;
      blockKey: string;
      entity: EntityInstance;
    };
    block.findEntityRanges(
      (character) => {
        if (character.getEntity() !== null) {
          const entity = contentState.getEntity(character.getEntity());
          if (entity.getType().toLowerCase() === DraftjsEntityType.MENTION) {
            selectedEntity = {
              entityKey: character.getEntity(),
              blockKey: block.getKey(),
              entity: contentState.getEntity(character.getEntity()),
            };
            return true;
          }
        }
        return false;
      },
      (start, end) => {
        entities.push({ ...selectedEntity, start, end });
      }
    );

    let offset = 0;
    nextEditorState = entities.reduce((prev, curr) => {
      const { entityKey, blockKey, entity, start, end } = curr;
      const contentState = prev.getCurrentContent();

      const name = entity.getData().mention?.user?.displayName ?? '';

      const selection = new SelectionState({
        anchorOffset: offset + start,
        anchorKey: blockKey,
        focusOffset: offset + end,
        focusKey: blockKey,
        isBackward: false,
        hasFocus: false,
      });

      offset = offset + (name.length - (end - start));

      const contentStateWithReplacedText = Modifier.replaceText(
        contentState,
        selection,
        name,
        undefined,
        entityKey
      );
      return EditorState.set(prev, {
        currentContent: contentStateWithReplacedText,
      });
    }, nextEditorState);
  });

  return nextEditorState;
};

export const getSelectionState = (content: ContentState): SelectionState => {
  const blockMap = content.getBlockMap();

  const key = blockMap.last().getKey();
  const length = blockMap.last().getLength();

  const selection = new SelectionState({
    anchorKey: key,
    anchorOffset: length,
    focusKey: key,
    focusOffset: length,
  });

  return selection;
};

export const getContentWithMention = (mentionData: {
  _id: string;
  displayName: string;
  postId: string;
}): ContentState => {
  return convertFromRaw({
    blocks: [
      {
        key: genKey(),
        text: `${mentionData.displayName} `,
        type: 'unstyled',
        depth: 0,
        inlineStyleRanges: [],
        entityRanges: [
          {
            offset: 0,
            length: mentionData.displayName.length,
            key: 0,
          },
        ],
        data: {},
      },
    ],
    entityMap: {
      '0': {
        type: DraftjsEntityType.MENTION,
        mutability: 'IMMUTABLE',
        data: {
          mention: {
            userId: mentionData._id,
            postId: mentionData.postId,
          },
        },
      },
    },
  });
};
